/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { NewVendorInfo } from '../models/new-vendor-info';
import { VendorInfo } from '../models/vendor-info';
import { VendorInfoPartial } from '../models/vendor-info-partial';
import { VendorInfoWithRelations } from '../models/vendor-info-with-relations';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({
  providedIn: 'root',
})
export class VendorInfoControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation vendorInfoControllerUploadVendorInfoExcel
   */
  static readonly VendorInfoControllerUploadVendorInfoExcelPath = '/excel-uploads/uploadVendorInfoExcel';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadVendorInfoExcel()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadVendorInfoExcel$Response(params: {
    context?: HttpContext

    /**
     * multipart/form-data value.
     */
    body: {
}
  }
): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, VendorInfoControllerService.VendorInfoControllerUploadVendorInfoExcelPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `uploadVendorInfoExcel$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadVendorInfoExcel(params: {
    context?: HttpContext

    /**
     * multipart/form-data value.
     */
    body: {
}
  }
): Observable<any> {

    return this.uploadVendorInfoExcel$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation vendorInfoControllerCount
   */
  static readonly VendorInfoControllerCountPath = '/vendor-infos/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, VendorInfoControllerService.VendorInfoControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
    context?: HttpContext
  }
): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation vendorInfoControllerBatchDeleteByIds
   */
  static readonly VendorInfoControllerBatchDeleteByIdsPath = '/vendor-infos/deleteByIds/{model}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `batchDeleteByIds()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  batchDeleteByIds$Response(params: {
    model: string;
    context?: HttpContext
    body?: Array<any>
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, VendorInfoControllerService.VendorInfoControllerBatchDeleteByIdsPath, 'post');
    if (params) {
      rb.path('model', params.model, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `batchDeleteByIds$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  batchDeleteByIds(params: {
    model: string;
    context?: HttpContext
    body?: Array<any>
  }
): Observable<{
}> {

    return this.batchDeleteByIds$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation vendorInfoControllerFindBidBaseData
   */
  static readonly VendorInfoControllerFindBidBaseDataPath = '/vendor-infos/findBidBaseData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findBidBaseData()` instead.
   *
   * This method doesn't expect any request body.
   */
  findBidBaseData$Response(params?: {
    vendorCode?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, VendorInfoControllerService.VendorInfoControllerFindBidBaseDataPath, 'post');
    if (params) {
      rb.query('vendorCode', params.vendorCode, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findBidBaseData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findBidBaseData(params?: {
    vendorCode?: string;
    context?: HttpContext
  }
): Observable<{
}> {

    return this.findBidBaseData$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation vendorInfoControllerFindProjectItem
   */
  static readonly VendorInfoControllerFindProjectItemPath = '/vendor-infos/findProjectItem';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findProjectItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  findProjectItem$Response(params?: {
    dbName?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, VendorInfoControllerService.VendorInfoControllerFindProjectItemPath, 'post');
    if (params) {
      rb.query('dbName', params.dbName, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findProjectItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findProjectItem(params?: {
    dbName?: string;
    context?: HttpContext
  }
): Observable<{
}> {

    return this.findProjectItem$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation vendorInfoControllerFindVendorData
   */
  static readonly VendorInfoControllerFindVendorDataPath = '/vendor-infos/findVendorData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findVendorData()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findVendorData$Response(params?: {
    dbName?: string;
    context?: HttpContext
    body?: {
}
  }
): Observable<StrictHttpResponse<VendorInfo>> {

    const rb = new RequestBuilder(this.rootUrl, VendorInfoControllerService.VendorInfoControllerFindVendorDataPath, 'post');
    if (params) {
      rb.query('dbName', params.dbName, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VendorInfo>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findVendorData$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findVendorData(params?: {
    dbName?: string;
    context?: HttpContext
    body?: {
}
  }
): Observable<VendorInfo> {

    return this.findVendorData$Response(params).pipe(
      map((r: StrictHttpResponse<VendorInfo>) => r.body as VendorInfo)
    );
  }

  /**
   * Path part for operation vendorInfoControllerFindById
   */
  static readonly VendorInfoControllerFindByIdPath = '/vendor-infos/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: number;
    filter?: any;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<VendorInfoWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, VendorInfoControllerService.VendorInfoControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VendorInfoWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: number;
    filter?: any;
    context?: HttpContext
  }
): Observable<VendorInfoWithRelations> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<VendorInfoWithRelations>) => r.body as VendorInfoWithRelations)
    );
  }

  /**
   * Path part for operation vendorInfoControllerReplaceById
   */
  static readonly VendorInfoControllerReplaceByIdPath = '/vendor-infos/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `replaceById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  replaceById$Response(params: {
    id: number;
    context?: HttpContext
    body?: VendorInfo
  }
): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, VendorInfoControllerService.VendorInfoControllerReplaceByIdPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `replaceById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  replaceById(params: {
    id: number;
    context?: HttpContext
    body?: VendorInfo
  }
): Observable<any> {

    return this.replaceById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation vendorInfoControllerDeleteById
   */
  static readonly VendorInfoControllerDeleteByIdPath = '/vendor-infos/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, VendorInfoControllerService.VendorInfoControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: number;
    context?: HttpContext
  }
): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation vendorInfoControllerUpdateById
   */
  static readonly VendorInfoControllerUpdateByIdPath = '/vendor-infos/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: number;
    context?: HttpContext
    body?: VendorInfoPartial
  }
): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, VendorInfoControllerService.VendorInfoControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: number;
    context?: HttpContext
    body?: VendorInfoPartial
  }
): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation vendorInfoControllerFind
   */
  static readonly VendorInfoControllerFindPath = '/vendor-infos';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<VendorInfoWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, VendorInfoControllerService.VendorInfoControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<VendorInfoWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
    context?: HttpContext
  }
): Observable<Array<VendorInfoWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<VendorInfoWithRelations>>) => r.body as Array<VendorInfoWithRelations>)
    );
  }

  /**
   * Path part for operation vendorInfoControllerCreate
   */
  static readonly VendorInfoControllerCreatePath = '/vendor-infos';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    context?: HttpContext
    body?: NewVendorInfo
  }
): Observable<StrictHttpResponse<VendorInfo>> {

    const rb = new RequestBuilder(this.rootUrl, VendorInfoControllerService.VendorInfoControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VendorInfo>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    context?: HttpContext
    body?: NewVendorInfo
  }
): Observable<VendorInfo> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<VendorInfo>) => r.body as VendorInfo)
    );
  }

  /**
   * Path part for operation vendorInfoControllerUpdateAll
   */
  static readonly VendorInfoControllerUpdateAllPath = '/vendor-infos';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAll()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAll$Response(params?: {
    where?: any;
    context?: HttpContext
    body?: VendorInfoPartial
  }
): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, VendorInfoControllerService.VendorInfoControllerUpdateAllPath, 'patch');
    if (params) {
      rb.query('where', params.where, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateAll$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAll(params?: {
    where?: any;
    context?: HttpContext
    body?: VendorInfoPartial
  }
): Observable<LoopbackCount> {

    return this.updateAll$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

}
